'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Kernel = function () {
    function Kernel() {
        _classCallCheck(this, Kernel);

        this.factories = [];
    }

    _createClass(Kernel, [{
        key: 'registerComponent',
        value: function registerComponent(uname, factory) {

            var wrapper = factory;

            if (isNativeClass(factory)) {
                wrapper = function wrapper($html) {
                    return new factory($html);
                };
            }

            this.factories[uname] = wrapper;
            return this;
        }
    }, {
        key: 'createComponent',
        value: function createComponent($html) {

            var uname = $html.data('mount');

            if (!uname) return null;

            var factory = this.factories[uname];
            if (!factory) return null;

            return factory($html);
        }
    }, {
        key: 'bindComponents',
        value: function bindComponents($view) {
            var self = this;
            $view.find('[data-mount]').each(function (idx, node) {

                var $node = $(node);

                if ($node.data('component')) return null;

                var component = self.createComponent($node);
                $node.data('component', component);
            });
        }
    }]);

    return Kernel;
}();

exports.default = Kernel;


function isNativeClass(thing) {
    return typeof thing === 'function' && thing.hasOwnProperty('prototype');
}